export const NewsService = require('./news').default;
export const BaseService = require('./base').default;
export const UserService = require('./user').default;
export const RemindService = require('./remind').default;
export const MatchService = require('./match').default;
export const TYCService = require('./tyc').default;
export const CommonService = require('./common').default;
export const WXService = require('./wx').default;
export const DemandService = require('./DemandService').default;
export const ExpertService = require('./ExpertService').default;
export const ProjectService = require('./ProjectService').default;
export const ResultService = require('./ResultService').default;
export const StarService = require('./StarService').default;
export const WorkstationService = require('./WorkstationService').default;

export const uploadUrl = "/web/upload";